"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Checkbox = void 0;
var React = _interopRequireWildcard(require("react"));
var _utils = require("../utils");
var _ui = require("../../ui");
require("../../../src/ui/checkbox/checkbox.module.scss");
const _excluded = ["children", "className", "checked", "color", "direction", "isIndeterminate", "isStateless", "labelStyle", "tabIndex", "aria-selected", "data-index", "onChange"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
// accessibility ok

const Checkbox = exports.Checkbox = /*#__PURE__*/React.forwardRef((props, ref) => {
  let {
      children,
      className,
      checked,
      color,
      direction,
      isIndeterminate,
      isStateless,
      labelStyle,
      tabIndex = 0,
      ['aria-selected']: ariaSelected,
      ['data-index']: dataIndex,
      onChange
    } = props,
    attributesOriginal = _objectWithoutProperties(props, _excluded),
    attributes = attributesOriginal;
  const [isChecked, setIsChecked] = React.useState(checked);
  className = (0, _utils.ClassNames)('kui-checkbox', isIndeterminate ? 'kui-checkbox--indeterminate' : null, color ? 'kui-checkbox--color_' + color : null, direction ? 'kui-checkbox--direction_' + direction : null, props.disabled ? 'kui-checkbox--disabled' : null, className);
  attributes.type = 'checkbox';
  attributes.className = 'kui-checkbox__input';
  attributes.onChange = e => {
    if (!isStateless) setIsChecked(!isChecked);
    if (onChange) onChange(e);
  };
  const onKeyDown = e => {
    if (!e || attributes.disabled) return;
    if (e.key === ' ') {
      e.preventDefault();
      attributes.onChange(e);
    }
  };
  React.useEffect(() => {
    setIsChecked(checked);
  }, [checked]);
  return /*#__PURE__*/React.createElement(_ui.Label, {
    className: className,
    ref: ref,
    tabIndex: tabIndex,
    role: 'checkbox',
    "aria-checked": isChecked,
    "aria-disabled": attributes.disabled,
    "aria-selected": ariaSelected,
    "data-index": dataIndex,
    onKeyDown: onKeyDown,
    style: labelStyle
  }, /*#__PURE__*/React.createElement("input", _extends({
    checked: isChecked
  }, attributes)), /*#__PURE__*/React.createElement("span", {
    className: "kui-checkbox__label"
  }, children, /*#__PURE__*/React.createElement(_ui.Icon, {
    className: "kui-checkbox__checkmark",
    xlink: "done"
  })));
});
Checkbox.defaultProps = {
  checked: false,
  onChange: () => undefined,
  color: null,
  direction: 'right'
};
Checkbox.displayName = 'Checkbox';